import { createSelector } from 'reselect';

const mobileno = (state) => state.newuser.mobileNumber;
const rolename=(state) => state.newuser.role;
const usercode = (state) => state.newuser.usercode;
const error = (state) => state.newuser.error;
export const getMobileNo = createSelector([mobileno], (data) => data);
export const getRole = createSelector([rolename], (data) => data);
export const getUserCode = createSelector([usercode], (data) => data);
export const getError = createSelector([error], (data) => data);
